<template>
      <file-pond v-model="myFiles" :server="{
          process: process()
      }"></file-pond>  
</template>

<script>
import vueFilePond from "vue-filepond";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import FilePondPluginImageExifOrientation from "filepond-plugin-image-exif-orientation";
import FilePondPluginImageTransform from "filepond-plugin-image-transform";
const uuid = require("uuid/v4");
import { storage } from "@/plugins/firebase";
// Register the plugin
// Create component
const FilePond = vueFilePond(
  FilePondPluginFileValidateType,
  FilePondPluginImagePreview,
  FilePondPluginImageExifOrientation,
  //FilePondPluginImageTransform
);
export default {
  props: {
    value: {
      type: String,
      default: () => null
    }
  },
  data: function() {
    return { myFiles: [] };
  },
  methods: {
    handleFilePondInit: function() {
      console.log("FilePond has initialized");
      // FilePond instance methods are available on `this.$refs.pond`
    },
    updateValue: function(url) {
      this.$emit("input", url);
    },
    process: function() {
      let ref = storage.ref();
      let senol = " senol tas";
      let emit = this.updateValue;
      return async (
        fieldName,
        file,
        metadata,
        load,
        error,
        progress,
        abort
      ) => {
        let uid = uuid();
        let child = ref.child("/childimages/" + uid);
        let uploadTask = child.put(file);
        // Register three observers:
        // 1. 'state_changed' observer, called any time the state changes
        // 2. Error observer, called on failure
        // 3. Completion observer, called on successful completion
        uploadTask.on(
          "state_changed",
          function(snapshot) {
            // Observe state change events such as progress, pause, and resume
            // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
            var progress2 =
              (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            progress(true, snapshot.bytesTransferred, snapshot.totalBytes);
            switch (snapshot.state) {
              case ref.TaskState.PAUSED: // or 'paused'
                console.log("Upload is paused");
                break;
              case ref.TaskState.RUNNING: // or 'running'
                console.log("Upload is running");
                break;
            }
          },
          function(e) {
            // Handle unsuccessful uploads
            error(e);
          },
          async function() {
            // Handle successful uploads on complete
            // For instance, get the download URL: https://firebasestorage.googleapis.com/...
            uploadTask.snapshot.ref
              .getDownloadURL()
              .then(function(downloadURL) {
                console.log("File available at", downloadURL);
                emit(downloadURL);
                });
          }
        );
      };
    }
  },
  components: {
    FilePond
  }
};
</script>
<style>
.filepond--panel > .filepond--panel-root {
  border-radius: 0;
}
</style>